import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { GetStoreProcurementReportApi } from "../../Api/Procurement/StoreProcurementReports";

// Loads one Store/Procurement report or dashboard from the API. `params` must be a stable value (state or a memo).
// Returns [data, loading]; data stays `initial` until the response arrives or when the request fails.
export default function useReportData(name, initial = [], params) {
  const [data, setData] = useState(initial);
  const [loading, setLoading] = useState(true);
  const paramKey = JSON.stringify(params || {});

  useEffect(() => {
    let alive = true;
    setLoading(true);
    GetStoreProcurementReportApi(name, params).then((res) => {
      if (!alive) {
        return;
      }
      if (res?.data?.IsSuccess) {
        setData(res.data.Data);
      } else {
        toast.error(res?.data?.Message || "Could not load the report");
      }
      setLoading(false);
    });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, paramKey]);

  return [data, loading];
}
